import React, { useState } from 'react';
import { Box, Grid, } from '@mui/material';
// import cancel from '../../../../assets/images/logos/cancel.svg';
import AuthFooter from 'ui-component/cards/AuthFooter';
import Image from 'assets/images/stockGlobalImage.svg';
import { Stack, styled } from '@mui/system';
import { shouldForwardProp } from '@mui/system';
import { Typography } from '@mui/material';
import finvestaLogo from 'assets/SVG/finvesta-logo.svg';
import shieldIcon from 'assets/SVG/shield.svg';
import AuthCardWrapper from './HomeCardWrapper';
import aadharImage from 'assets/SVG/aadhaar.svg';
import panImage from 'assets/SVG/pan.svg';
import bankImage from 'assets/SVG/bankdetails.svg';
import videoImage from 'assets/SVG/videokyc.svg';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router';
import Terms from 'ui-component/cards/PrivacyPolicy/Terms';
// import { Link } from 'react-router-dom';

// import SigninForm from '../auth-forms/SigninForm';

const StartKyc = () => {
  const Nav = useNavigate();
  // const theme = useTheme();

  const [Data, setData] = useState('');

  const handleChange = (name, event) => {
    setData({ ...Data, [name]: event });
  };
  console.log('data', Data);

  const StyledHeader = styled(Box, { shouldForwardProp })(() => ({
    height: '15%',
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.20) 7.14%, #FFF 53.93%)',
    zIndex: 1
  }));
  const handleTermsModelOpen = () => {
    setTermsOpen(true);
  };
  const [TermsOpen, setTermsOpen] = useState(false);

  const handleTermsModelBack = () => {
    setTermsOpen(false);
  };

  return (
    <>
      <Terms open={TermsOpen} handleClose={handleTermsModelBack} />

      {/* <Header/> */}
      <Grid container sx={{ height: '100vh', overflow: 'hidden' }}>
        <Grid
          item
          xl={5}
          lg={4}
          md={3}
          sm={0}
          xs={0}
          sx={{
            background: `url(${Image}) lightgray 50% / cover no-repeat`,
            objectFit: 'contain',
            overflow: 'hidden',
            display: { xl: 'flex', lg: 'flex', md: 'flex', sm: 'none', xs: 'none' }
          }}
        >
          <StyledHeader>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" height="100%" pl={10}>
              <img src={finvestaLogo} alt="" />
            </Stack>
          </StyledHeader>
          {/* <img src={Image} alt='img' width='100%'/> */}
          <Stack alignItems="center" justifyContent="center" width="70%" pl={10}>
            <Typography variant="h2" color="#fff">
              Effortless payments, endless possibilities. Experience financial freedom.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xl={7} lg={8} md={9} sm={12} xs={12} sx={{ zIndex: 2, padding: '50px' }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="space-between"
            height="100vh"
            mt={{ xl: 1, lg: 1, md: 2, sm: 2, xs: 2 }}
          >
            <Grid item xl={12} lg={12} md={12} sm={12}>
              <Grid container justifyContent="space-between" alignItems="space-between" width="100%">
                <Grid item xl={4} lg={6} md={12} sm={12} xs={12}>
                  <Grid item xl={12}>
                    <Typography variant="h3" sx={{ fontSize: '20px', fontWeight: 700 }}>
                      Welcome to Finvesta
                    </Typography>
                  </Grid>
                  <Grid item xl={12} mt={1}>
                    <Stack direction="row" gap={1}>
                      <img src={shieldIcon} alt="" />
                      <Typography variant="h5" sx={{ fontSize: '14px' }} color="#868687">
                        100% fully secured and safe transactions
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid item xl={4} lg={6} md={12} sm={12} xs={12}>
                  <Stack direction="row" gap={1} justifyContent="flex-end">
                    <Typography variant="h5" color="#616161">
                      Already have an account?
                    </Typography>
                    {/* <Link to={'/Signin'} underline="none" > */}
                    <Typography
                      variant="h5"
                      color="#688B2A"
                      sx={{ fontWeight: '600', cursor: 'pointer' }}
                      onClick={() => {
                        Nav('/Signin');
                      }}
                    >
                      Sign In Now
                    </Typography>
                    {/* </Link> */}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xl={12}>
              <Grid container>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="h5" color="#592375" sx={{ fontSize: '16px', fontWeight: 610 }}>
                    Fill In Your KYC Details
                  </Typography>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} mt={1}>
                  <Typography variant="h6" color="#878687" sx={{ fontSize: '14px' }}>
                    Details to keep handy for easy & quick verification
                  </Typography>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pl={0} mt={2}>
                  <AuthCardWrapper>
                    <Grid container spacing={{ xl: 10, lg: 8, md: 10, sm: 4, xs: 2 }} justifyContent="space-between">
                      <Grid item xl={3}>
                        <Stack alignItems="center" gap={1}>
                          <img src={aadharImage} alt="shield" width="100%" />
                          <Typography variant="h4" sx={{ fontSize: '14px' }}>
                            Aadhaar Card
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xl={3}>
                        <Stack alignItems="center" gap={1}>
                          <img src={panImage} alt="shield" width="100%" />
                          <Typography variant="h4" sx={{ fontSize: '14px' }}>
                            Pan Card
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xl={3}>
                        <Stack alignItems="center" gap={1}>
                          <img src={bankImage} alt="shield" width="100%" />
                          <Typography variant="h4" sx={{ fontSize: '14px' }}>
                            Bank Details
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xl={3}>
                        <Stack alignItems="center" gap={1}>
                          <img src={videoImage} alt="shield" width="100%" />
                          <Typography variant="h4" sx={{ fontSize: '14px' }}>
                            Video Kyc
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </AuthCardWrapper>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} mt={6}>
                  <Stack direction="row" gap={0.5} alignItems="center">
                    <Checkbox
                      // defaultChecked
                      value={Data.check}
                      onChange={(e) => handleChange('check', e.target.checked)}
                      sx={{
                        '&.Mui-checked': {
                          color: '#688B2A',
                          borderRadius: '50%'
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)' // Hover background color
                        },
                        '&.Mui-disabled': {
                          color: 'action.disabled' // Color when disabled
                        }
                      }}
                    />
                    <Typography variant="h6" color="#202222" sx={{ fontSize: '14px' }}>
                      I provide my consent for
                    </Typography>
                    <Typography
                      variant="h6"
                      color="#688B2A"
                      sx={{ fontSize: '14px', cursor: 'pointer' }}
                      onClick={() => handleTermsModelOpen()}
                    >
                      Terms & Conditions
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xl={12} mt={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{ backgroundColor: '#592375', height: '40px', borderRadius: '8px', fontWeight: '500', fontSize: '16px' }}
                    size="medium"
                    onClick={() => {
                      Data && Data.check ? Nav('/Onboarding') : alert('Please accept the terms and condition');
                    }}
                  >
                    START KYC PROCESS
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mb: 3 }}>
              <AuthFooter />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default StartKyc;
